module.exports = __webpack_public_path__ + "static/img/course09.36e46e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course09.jpg
// module id = AEAZ
// module chunks = 101